import { connect } from 'react-redux';

import MotorSelect from './motor';
import { addMotor, removeMotor } from '../../../reducers/cart';

export default connect((state) => state, { addMotor, removeMotor })(
  MotorSelect
);
